import { methods } from '@streamlabs-core/sl-one-fe-sdk';

export const doSLIDRegisterFlow = async () => {
  await methods.connect({
    companyId: 'studio',
    noAuthTarget: 'signup',
    forceVerify: true,
  });
};

export const connectToStreamlabsId = async () => {
  await methods.connect({
    companyId: 'studio',
    intent: 'upgrade',
  });
};
